// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__11n24","notes":"Notes_notes__3Vkbf"};